import { AsyncPipe, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { SitecoreEventDetailsConfig } from '@frontend/sports/common/client-config-data-access';

import { DartsScoreboardBaseComponent } from '../scoreboard-base/darts-scoreboard-base.component';

@Component({
    selector: 'ms-darts-scoreboard-header',
    templateUrl: './darts-scoreboard-header.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, AsyncPipe],
})
export class DartsScoreboardHeaderComponent extends DartsScoreboardBaseComponent {
    constructor(public override sitecoreEventDetails: SitecoreEventDetailsConfig) {
        super(sitecoreEventDetails);
    }
}
